import React, {Component} from 'react';
import {connect} from 'react-redux';
import { not } from 'ramda';
import {Link} from 'react-router-dom';

import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {ButtonSuccessModal, ButtonDangerModal, ButtonWrap, LinkInfo, ButtonDangerDelete} from 'components/buttons';

import Spinner from 'spinner';
import {DocumentList} from 'components/documents';
import Breadcrumbs from 'components/breadcrumbs';
import Box from 'components/box';
import Image from 'components/image';
import {Divider} from 'components/common';

import {loadInstitutionPersonalDetail, deleteInstitutionPersonal} from 'redux/actions/admin/institution';

import doctor from 'images/general/doctor.svg';
import close from 'images/general/close.svg';

const mapStateToProps = (state) => ({
  personalDetail: state.adminInstitution.get('personalInstitution'),
  user: state.auth.get('user')
});

const mapDispatchToProps = (dispatch) => ({
    loadInstitutionPersonal: (personalInstitutionId, institutionId) => dispatch(loadInstitutionPersonalDetail(personalInstitutionId, institutionId)),
    deleteInstitutionPersonal: (personalInstitutionId, institutionId) => dispatch(deleteInstitutionPersonal(personalInstitutionId, institutionId))
});

class PersonalDetail extends Component {

  state = {
    modalOpen: false
  }

  multilineStyle = {
    whiteSpace: 'pre-wrap'
  }

  toggleModal = () => this.setState(prevState => ({modalOpen: !prevState.modalOpen}))

  onModalOk = () => {
    this.toggleModal()
    const personalId = this.props.match.params.personalInstitution_id;
    const institutionId = this.props.match.params.institution_id
    this.props.deleteInstitutionPersonal(personalId, institutionId)
  }

  renderAccountLink = () => {
    if (this.props.personalDetail.get('doctor_data')) {
      return (
        <LinkInfo
          to={`/admin/doctors/detail/${this.props.personalDetail.getIn(['doctor_data', 'id'])}`}>
          Обліковий запис
        </LinkInfo>
      )
    }
  }

  renderImageMaxWidth = () => this.props.personalDetail.getIn(["user_data", "photo"]) ? '260px' : '100px'

  renderAccountInfo = (key, stub = 'інформація відсутня') => {
    const keyToFind = typeof key === 'string' ? [key] : key
    const valueToRender = this.props.personalDetail.getIn(keyToFind)
    if(typeof valueToRender === 'boolean') {
      return valueToRender ? 'Так' : 'Ні'
    }
    return this.props.personalDetail.getIn(keyToFind) || stub
  }

  renderBreadcrumbs = () => {
    const isAdminInstitution = this.props.user && this.props.user.get('is_admin_institution') && !this.props.user.get('is_superuser')
    if(isAdminInstitution) {
      return (
        <Breadcrumbs>
          <li><Link to={`/admin/institutions/detail/${this.props.match.params.institution_id}`}>{this.props.personalDetail.getIn(['institution_data', 'short_title'])}</Link></li>
        </Breadcrumbs>
      )
    }
    return (
      <Breadcrumbs>
        <li><Link to="/admin/">Головна</Link></li>
        <li><Link to="/admin/institutions">Установи</Link></li>
        <li><Link to={`/admin/institutions/detail/${this.props.match.params.institution_id}`}>{this.props.personalDetail.getIn(['institution_data', 'short_title'])}</Link></li>
      </Breadcrumbs>
    )
  };

  componentWillMount() {
    const personalId = this.props.match.params.personalInstitution_id;
    const institutionId = this.props.match.params.institution_id
    this.props.loadInstitutionPersonal(personalId, institutionId);
  }

  render() {
    const item = this.props.personalDetail;

    if(not(item)) return <Spinner />

    const personalId = this.props.match.params.personalInstitution_id;
    const institutionId = this.props.match.params.institution_id

    return (
      <div>
        <div>
          {this.renderBreadcrumbs()}
          <Box>
            <h2>{item.getIn(['user_data', 'last_name'])} {item.getIn(['user_data', 'first_name'])} {item.getIn(['user_data', 'middle_name'])}</h2>
            <DocumentList>
              <li>
                <Image backgroundImage={item.getIn(["user_data", "photo"]) || doctor} alt='photo' maxWidth={this.renderImageMaxWidth()}> </Image>
              </li>
              <li><span>Посада: </span><strong>{this.renderAccountInfo('position_title')}</strong></li>
              <li><span>Спеціальність: </span><strong>{this.renderAccountInfo(['doctor_data', 'profession_classification_data', 'profession_title'])}</strong></li>
              <li><span>Установа: </span><strong>{this.renderAccountInfo(['institution_data', 'full_title'])}</strong></li>
              <li><span>Номер кабінету: </span><strong>{this.renderAccountInfo('cabinet_number')}</strong></li>
              <li><span>Телефон: </span><strong>{this.renderAccountInfo('phone')}</strong></li>
              <li><span>Пошта: </span><strong>{this.renderAccountInfo(['user_data', 'email'])}</strong></li>
              <li><span>Графік роботи: </span><span style={{lineHeight: "1.3", fontWeight: "normal", whiteSpace: "pre-wrap"}}><strong>{this.renderAccountInfo('schedule')}</strong></span></li>
              {/* <li><span>Рейтинг лікаря: </span>{changeRating(item.get('rating'))} {item.get('rating_count') > 0 && <span style={{fontWeight: "normal"}}> (Кількість оцінок: {item.get('rating_count')})</span>}</li> */}
              <li><span>Додаткова інформація: </span><strong style={this.multilineStyle}>{this.renderAccountInfo('comment', 'Додаткова інформація відсутня')}</strong></li>
              <li><span>Порядок у списку: </span><strong style={this.multilineStyle}>{this.renderAccountInfo('sort_priority', 'Не визначений')}</strong></li>
              <Divider />
              <h4>Ролі користувача:</h4>
              <li><span>Оператор (робота з розсилками документів): </span><strong>{Boolean(item.get('is_responsible') && item.get('is_operator')) ? 'Так' : 'Ні'}</strong></li>
              <li><span>Адміністрація (відгуки, звернення, оцінки): </span><strong>{this.renderAccountInfo('is_manager_institution')}</strong></li>
              <li><span>Реєстратура (запис до лікаря): </span><strong>{this.renderAccountInfo('is_registry')}</strong></li>
              <li><span>Адміністратор установи: </span><strong>{this.renderAccountInfo('is_admin')}</strong></li>
            </DocumentList>
            <Divider />
            <LinkInfo to={`/admin/institutions/${institutionId}/edit-personal/${personalId}`}>
              Редагувати
            </LinkInfo>
            {this.renderAccountLink()}
            <ButtonDangerDelete value="Видалити" onClick={this.toggleModal}>Видалити</ButtonDangerDelete>
          </Box>

          <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.toggleModal}
                      className={{
                        base: 'modalContent',
                        afterOpen: 'myClass_after-open',
                        beforeClose: 'myClass_before-close'
                      }} contentLabel="Підтвердження запису"
                      overlayClassName={{
                        base: 'modalOverlay',
                        afterOpen: 'myOverlayClass_after-open',
                        beforeClose: 'myOverlayClass_before-close'
                      }}>
            <div>
              <Modal>
                <CloseModal>
                  <div>
                    <img src={close} alt="закрити" onClick={this.toggleModal} />
                  </div>
                </CloseModal>

                <ModalContent>
                  <h3>
                    Ви впевнені, що хочете видалити персонал&nbsp;
                    {item.getIn(['user_data', 'last_name'])} {item.getIn(['user_data', 'first_name'])} {item.getIn(['user_data', 'middle_name'])}?
                  </h3>
                  <ButtonWrap>
                    <ButtonSuccessModal onClick={this.onModalOk} value="Так"/>
                    <ButtonDangerModal value="Ні" onClick={this.toggleModal}/>
                  </ButtonWrap>
                </ModalContent>

              </Modal>
            </div>
          </ReactModal>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetail);




// WEBPACK FOOTER //
// ./src/admin/institutions/personal-detail.js